<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap_small">
<p class="image"><a id="page_272"></a><img alt="images" src="images/f0272-01.jpg"/></p>
</div>
<div id="copyright">
<p>Copyright © 2016 by Lisa Swerling and Ralph Lazar.<br/>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 978-1-4521-5201-1 (pb)<br/>ISBN 978-1-4521-5275-2 (epub 2)<br/>ISBN 978-1-4521-5450-3 (epub 3)<br/>ISBN 978-1-4521-5449-7 (mobi)</p><br/>
<p>Design by Lisa Swerling and Ralph Lazar</p>
<p>10 9 8 7 6 5 4 3 2 1</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, CA 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03copyright.vue?779047d0